export const AppRoute = {
  AntragOverview: 'antrags-uebersicht',
  AutoChangeEmail: 'auto-email-aendern/:id',
  Bescheid: 'bescheide',
  CallbackLogin: 'callback/code-callback',
  CallbackLogout: 'callback/logout',
  DashboardPage: 'dashboard',
  Downloads: 'downloads',
  EinreichungNew: 'meine-antraege',
  EinreichungOld: 'einreichen',
  EmailValidation: 'validierung',
  Help: 'hilfe-faq',
  HelpDetail: 'hilfe-faq/detail',
  Info: 'info',
  InfoContact: 'info/kontakt',
  InfoImprint: 'info/impressum',
  InfoPrivacy: 'info/datenschutz',
  Landing: 'landing',
  Login: 'anmelden',
  Logout: 'logout',
  Maintenance: 'maintenance',
  NewsFeed: 'news-feed',
  NewValidationLink: 'neue-bestaetigungs-email',
  NotFound: 'not-found',
  PasswordForgotten: 'passwort-vergessen',
  PinValidation: 'pin-speichern',
  Registration: 'registrieren',
  ResetPassword: 'passwort-vergessen/:pn/:code',
  Settings: 'einstellungen',
  SettingsChangeEmail: 'email-aendern',
  SettingsChangePassword: 'passwort-aendern',
  SettingsDeleteAccount: 'account-loeschen',
  SettingsNewPin: 'neuer-pin',
  SettingsPrivacy: 'datenschutz',
  StartEinreichung: 'meine-antraege/(overlay:assistent)',
  Tutorial: 'tutorial',
  UnfinishedRegistration: 'registrierung-abschliessen',
  Update: 'update-page',
  Videos: 'videos',
} as const;
